<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="fresh-seed-bag-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            
            <el-table-column
                prop="qrCode.code"
                label="QR Code"
                width="70"
            />
            
            <el-table-column
                prop="isActiveFormatted"
                label="Is Active"
                width="70"
            />
            
            <el-table-column
                prop="currentAmount"
                label="Amount (g)"
                width="100"
            />
            
            <el-table-column
                prop="currentViability"
                label="Viability (%)"
                width="100"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
import { pollenBottleGetAll } from "@/api/pollen_bottle";

export default {
    props: {
        pollenId: {
            type: String | Number,
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        pollenId: {
            immediate: true,
            handler() {
                this.getAllPollenBottles();
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
        async getAllPollenBottles () {
            this.isLoading = true;
            let res = await pollenBottleGetAll({ "PollenId": this.pollenId });
            if (res) {
                this.tableData = res.items;
            }
            this.isLoading = false;
        }
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/PollenBottle/PollenBottleSimpleTable.vue